import { noop } from "lodash";
import { useMemo } from "react";
import * as React from "react";

import { SelectField } from "@livechat/design-system";

import { TeamHeaderItem, TeamSelectItem } from "./TeamItem";

export interface ITeamItem {
  id: string;
  name?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getItems(teams: ITeamItem[]) {
  return teams.map(team => ({
    key: team.id,
    props: {
      id: team.id,
      name: team.name,
    },
  }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getItemBody(item: ITeamItem) {
  // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  return <TeamSelectItem teamId={item.id} teamName={item.name} />;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getSelectedItemBody(item: ITeamItem) {
  // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  return <TeamHeaderItem teamId={item.id} teamName={item.name} />;
}

interface IDefaultProps {
  className?: string;
  description: React.ReactNode;
  itemBodyRenderer: (item: ITeamItem) => React.ReactNode;
  labelText: string;
  onDropdownToggle: (isOpen: boolean) => void;
  openedOnInit: boolean;
  placeholder: string;
  required: boolean;
  disabled?: boolean;
  selectedId: string;
  selectedItemBodyRenderer: (item: ITeamItem) => React.ReactNode;
}

interface IProps extends Partial<IDefaultProps> {
  teams: ITeamItem[];
  id: string;
  onSelect: (id: string) => void;
  dataTestId?: string;
}

export const TeamSelect: React.FC<IProps> = ({
  teams,
  itemBodyRenderer,
  onSelect,
  selectedId,
  selectedItemBodyRenderer,
  disabled,
  ...restProps
}) => {
  const items = useMemo(() => getItems(teams), [teams]);

  return (
    <SelectField
      // @ts-expect-error TS(2322)
      getItemBody={itemBodyRenderer}
      // @ts-expect-error TS(2322)
      getSelectedItemBody={selectedItemBodyRenderer}
      items={items}
      onItemSelect={onSelect}
      search
      searchProperty="name"
      // @ts-expect-error TS(2322)
      selected={selectedId}
      disabled={disabled}
      {...restProps}
    />
  );
};

TeamSelect.defaultProps = {
  description: null,
  itemBodyRenderer: getItemBody,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
  labelText: null,
  onDropdownToggle: noop,
  openedOnInit: false,
  placeholder: "Select",
  required: false,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
  selectedId: null,
  selectedItemBodyRenderer: getSelectedItemBody,
};
